import { render } from "./SubmitBtn.vue?vue&type=template&id=64b22496&ts=true"
import script from "./SubmitBtn.vue?vue&type=script&lang=ts"
export * from "./SubmitBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__